export const profileNavKey = {
    ADMIN: 'ADMIN',
    SELF_REGISTRATION_DATA: 'SELF-REGISTRATION-DATA',
    DONOR_DATA: 'DONOR-DATA',
    MEDICAL_DETAILS: 'MEDICAL-DETAILS',
    HLA_INFO: 'HLA-INFO',
    RECORDS: 'RECORDS',
    CT_SCAN: 'CT-SCAN',
    DECLINES: 'DECLINES',
    ACCEPTS: 'ACCEPTS',
    ADP: 'ADP',
};